/**
 * The request header that says which cycle a write is working in (migration 1019,
 * roadmap S-37). One definition: the app sends it, the API passes it on.
 */
export const ITEM_CYCLE_HEADER = 'x-item-cycle';
